export default function Blog() {
  return (
    <div className="main_basket">
      <h1>This is blog page</h1>
    </div>
  );
}
